/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Typography } from '@mui/material';

import { Namespaces } from '../../i18n';
import { HUModal2, HUModal2Props } from '../HUModal2/HUModal2';
import { useSimpleConfirmModalStyles } from './SimpleConfirmModal.styles';

type SimpleConfirmModalProps = Required<Pick<HUModal2Props, 'open'>> &
  Pick<HUModal2Props, 'disableEscapeKeyDown'> & {
    onCancel: () => any;
    onConfirm: () => any;
    confirmButtonText?: React.ReactNode;
    cancelButtonText?: React.ReactNode;
    message?: string | React.ReactNode;
    confirmButtonProps?: React.ComponentProps<typeof Button>;
    cancelButtonProps?: React.ComponentProps<typeof Button>;
  };

export function SimpleConfirmModal(props: SimpleConfirmModalProps) {
  const {
    onCancel,
    onConfirm,
    open,
    message,
    disableEscapeKeyDown,
    cancelButtonText,
    confirmButtonText,
    cancelButtonProps = {},
    confirmButtonProps = {},
  } = props;
  const classes = useSimpleConfirmModalStyles();
  const { t } = useTranslation([Namespaces.Common]);
  return (
    <HUModal2
      open={open}
      size="big"
      disableEscapeKeyDown={disableEscapeKeyDown}
      onClose={onCancel}
      disableRestoreFocus
      footer={() => (
        <div className={classes.modalFooterClass}>
          <Button {...confirmButtonProps} variant="contained" onClick={onConfirm} data-cy="confirm-modal-submit">
            {confirmButtonText || t(`${Namespaces.Common}:confirmation.yes`)}
          </Button>
          <Button {...cancelButtonProps} variant="outlined" onClick={onCancel} data-cy="confirm-modal-cancel">
            {cancelButtonText || t(`${Namespaces.Common}:confirmation.no`)}
          </Button>
        </div>
      )}
    >
      <Typography data-cy="simple-confirm-modal-message" variant={'body1'} classes={{ root: classes.modalTitle }}>
        {message}
      </Typography>
    </HUModal2>
  );
}
